export const toggleViewstate = () => {

  const btnToggleView = document.querySelectorAll(".js-viewstate-toggle");
  const view = document.querySelectorAll(".js-viewstate");

  const init = () => {
    bind();
  };

  const bind = () => {
    btnToggleView.forEach((btn) => {
      btn.addEventListener("click", function (e) {
        e.preventDefault();
        btnToggleView.forEach((btn) => {
          btn.classList.remove("is-active");
        });
        this.classList.add("is-active");
        let viewToToggle = this.getAttribute("data-viewstate");
        view.forEach((view) => {
          view.classList.remove("is-active");
          //Set the data-attribute viewstate to viewToToggle
          view.setAttribute("data-viewstate", viewToToggle);
        });
        
        // Dispatch event to reinitialize text panning for newly visible cells
        window.dispatchEvent(new CustomEvent('viewstate-changed', { 
          detail: { viewstate: viewToToggle } 
        }));
      });
    });
  };

  init();

};

